"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LodestarCoreTheme = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
const LodestarCoreTheme = (0, _lodestarUtils.createContext)("light", "LodestarCoreTheme");
exports.LodestarCoreTheme = LodestarCoreTheme;
//# sourceMappingURL=LodestarCoreTheme.js.map